module.exports = __webpack_public_path__ + "img/icon-Wingo.f8393ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-Wingo.png
// module id = GF2N
// module chunks = 0